import {useEffect, useRef} from 'react';

/**
 * `useRef` with current and old value support
 * @example
 * ```tsx
 * const [ref, oldRef] = useEnhancedRef(value);
 * ```
 */
export const useEnhancedRef = <T>(
	value: T,
): [React.MutableRefObject<T>, React.MutableRefObject<T>] => {
	const oldRef = useRef<T>(value);
	const ref = useRef<T>(value);

	useEffect(() => {
		oldRef.current = ref.current;
		ref.current = value;
	}, [value]);

	return [ref, oldRef];
};

export default useEnhancedRef;
